import React from 'react';
import { Emoji } from './Emoji';
export function Footer() {
  return <footer className="w-full border-t border-line bg-canvas py-12 sm:py-14" data-id="element-91" data-mp="3gf93arl2hy6u">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6" data-id="element-92" data-mp="3ghc3g4fxp7pa">
        <span className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-ink-900 sm:text-base sm:tracking-[0.24em]" data-id="element-93" data-mp="32pffmclatjyp">
          <Emoji symbol="🍽️" data-id="element-94" data-mp="3uesb1j9yv7im" />
          Close The Gap<span className="text-celeste-600" data-id="element-95" data-mp="3uftkjjbc3ly8">™</span>
        </span>
        <p className="mx-auto mt-4 max-w-md text-[14px] leading-relaxed text-ink-500 sm:text-[15px]" data-id="element-96" data-mp="37o7iyd163ey">
          El sistema de alimentación proteica N°1 para argentinos que quieren
          ganar músculo y perder peso sin perder el tiempo ni gastar de más.
        </p>

        <ul className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-7" data-id="element-97" data-mp="29zgkbzgigqll">
          <li data-id="element-98" data-mp="2eyjqjn8892v5">
            <a href="mailto:closethegap14@gmail.com" className="inline-flex items-center gap-2 break-all text-[13px] text-ink-700 transition-colors duration-150 ease-out hover:text-celeste-700 sm:text-sm" data-id="element-99" data-mp="2ez1l8ff8r90y">
              <Emoji symbol="📧" data-id="element-100" data-mp="3v7q5pow3wjfi" />
              closethegap14@gmail.com
            </a>
          </li>
          <li data-id="element-101" data-mp="3q8n125k1gf82">
            <a href="https://instagram.com/closethegap14" className="inline-flex items-center gap-2 text-[13px] text-ink-700 transition-colors duration-150 ease-out hover:text-celeste-700 sm:text-sm" data-id="element-102" data-mp="3q83t9ho3r77r">
              <Emoji symbol="📱" data-id="element-103" data-mp="33e5h7zjgmr5" />
              @closethegap14
            </a>
          </li>
          <li data-id="element-104" data-mp="hriipwfto62j">
            <a href="https://www.recursoclosethegap.shop" className="inline-flex items-center gap-2 break-all text-[13px] text-ink-700 transition-colors duration-150 ease-out hover:text-celeste-700 sm:text-sm" data-id="element-105" data-mp="hs1vyzuj26a8">
              <Emoji symbol="🌐" data-id="element-106" data-mp="mspndmmo4p4z" />
              www.recursoclosethegap.shop
            </a>
          </li>
        </ul>

        <div className="mt-10 border-t border-line pt-6" data-id="element-107" data-mp="twfp9wj4m1th">
          <p className="flex flex-wrap items-center justify-center gap-2 font-display text-[13px] font-bold text-celeste-700 sm:text-sm" data-id="element-108" data-mp="yty0xuoj2v56">
            “Tu heladera llena de proteína el lunes empieza el domingo a las 10
            de la mañana.”
            <Emoji symbol="🍽️" data-id="element-109" data-mp="18ksnl05orwr5" />
          </p>
          <p className="mt-3 text-[11px] text-ink-400 sm:text-xs" data-id="element-110" data-mp="1clmaprbb17iz">
            © Close The Gap™ 2025 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}